import React from 'react'

import OldLoginContainer from '../components/login-modal/OldLoginContainer'
const OldLoginScreen = props => <OldLoginContainer {...props} />

export default OldLoginScreen
